/* eslint-disable multiline-ternary */
import styled, { css } from 'styled-components';

const getSectionVariantBackgroundColor = (theme, variant) => {
  if (variant === 'primary') {
    return theme.colors.primary.blue;
  } if (variant === 'secondary') {
    return theme.colors.neutral.grey95;
  }
  // tertiary
  return theme.colors.neutral.white;
};

const getSectionVariantColor = (theme, variant) => {
  if (variant === 'primary') {
    return theme.colors.neutral.white;
  }
  // tertiary and secondary
  return theme.colors.neutral.grey29;
};

// eslint-disable-next-line import/prefer-default-export
export const GeneralSection = styled.section`
  && {
    ${({ theme, variant }) => css`
      padding-top: ${theme.spacing(12.5).rem()};
      padding-bottom: ${theme.spacing(12.5).rem()};
      max-width: unset;
      background-color: ${getSectionVariantBackgroundColor(theme, variant)};
      color: ${getSectionVariantColor(theme, variant)};
    `}
  }
`;

